import { isIncompleteString } from './stringHelpers.js';
import type { DSControlledDateTimePickerT } from '../react-desc-prop-types.js';

export const getValidationTimeStringMetaInfo = (
  timeString: string,
  getIsDisabledTime = (
    // eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
    timeS: string,
  ) => false,
): Partial<DSControlledDateTimePickerT.InternalInputsChangeMetaInfo> => {
  const metaInfo: Partial<DSControlledDateTimePickerT.InternalInputsChangeMetaInfo> = {};
  if (!isIncompleteString(timeString)) {
    metaInfo.isDisabledTime = getIsDisabledTime(timeString);
    if (metaInfo.isDisabledTime) metaInfo.suggestedErrorMsg = 'The selected time is not allowed';
  }

  return metaInfo;
};
